import React from "react";
import { SimpleGrid } from "@chakra-ui/react";
import CompanyCard from "./CompanyCard";
import { hireup, optergy, codecamp } from "../../constants/constants";

const companies = [
  {
    companyName: hireup.companyName,
    logoPlaceholder: hireup.logo,
    descriptionPlaceholder: hireup.details,
    weblink: hireup.websiteLink,
    colorGradient: hireup.colorGradient,
    fontFamily: hireup.fontFamily,
    fontWeight: hireup.fontWeight,
    datesWorked: "2022 - present",
    position: "Senior Software Engineer",
  },
  {
    companyName: optergy.companyName,
    logoPlaceholder: optergy.logo,
    descriptionPlaceholder: optergy.details,
    weblink: optergy.websiteLink,
    colorGradient: optergy.colorGradient,
    fontFamily: optergy.fontFamily,
    fontWeight: optergy.fontWeight,
    datesWorked: "2019 - 2022",
    position: "Software Engineer",
  },
  {
    companyName: codecamp.companyName,
    logoPlaceholder: codecamp.logo,
    descriptionPlaceholder: codecamp.details,
    weblink: codecamp.websiteLink,
    colorGradient: codecamp.colorGradient,
    fontFamily: codecamp.fontFamily,
    fontWeight: codecamp.fontWeight,
    datesWorked: "2016 - 2019",
    position: "Head Teacher",
  },
];

const CompanyCards: React.FC = () => {
  return (
    <SimpleGrid
      columns={{ base: 1, sm: 2, md: 3 }}
      spacing={{ base: 5, md: 8 }}
      width="100%"
    >
      {companies.map((company) => (
        <CompanyCard key={company.companyName} {...company} />
      ))}
    </SimpleGrid>
  );
};

export default CompanyCards;
